export const AXIS_ZOOM_MODE = {
  X: "x",
  Y: "y",
  BOTH: "both",
};

export function getHoveredAxis(mouseX, mouseY, plotArea) {
  const onXAxisArea =
    mouseY > plotArea.bottom &&
    mouseX >= plotArea.left &&
    mouseX <= plotArea.right;

  const onYAxisArea =
    mouseX < plotArea.left &&
    mouseY >= plotArea.top &&
    mouseY <= plotArea.bottom;

  if (onXAxisArea) return AXIS_ZOOM_MODE.X;
  if (onYAxisArea) return AXIS_ZOOM_MODE.Y;
  return AXIS_ZOOM_MODE.BOTH;
}
